import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Button, Stack, Typography } from '@mui/material';

export default function TravelPurchaseSummary({ total, onAddToShoppingCartClick = () => {}, isValid }) {
  const { t } = useTranslation();

  const isSubmitDisabled = !total.length || !isValid;

  return (
    <Stack mt={2} direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="body1" color="secondary.light">
        <Typography color="secondary.light" variant="body1" component="span" fontWeight={700}>
          {t('total')}:
        </Typography>{' '}
        {isSubmitDisabled ? '00.00' : total}
      </Typography>
      <Button disabled={isSubmitDisabled} variant="contained" onClick={onAddToShoppingCartClick}>
        {t('add_to_shopping_cart')}
      </Button>
    </Stack>
  );
}
